import { VIRTUAL_HEIGHT, VIRTUAL_WIDTH } from "../../config";
import { drawSceneBackground } from "../../utils/draw";
import type { GameContext, Scene } from "./Scene";

/**
 * Full-screen lockout shown to a banned player. There's no way out — it registers
 * no buttons and ignores flap/pause — so a banned account simply can't play. The
 * lock is driven by Game's self-poll: if the ban is lifted server-side, Game
 * swaps back to the menu.
 */
export class BanScene implements Scene {
  constructor(private readonly ctxMgr: GameContext) {}

  enter(): void {
    this.ctxMgr.buttons.clear();
    this.ctxMgr.audio.music.stop();
  }

  exit(): void {
    this.ctxMgr.buttons.clear();
  }

  onFlap(): void {
    // swallow — a banned player can't start a run
  }

  onPauseToggle(): void {
    // swallow
  }

  update(_dt: number): void {
    // frozen
  }

  render(ctx: CanvasRenderingContext2D): void {
    drawSceneBackground(ctx);
    ctx.fillStyle = "rgba(0,0,0,0.6)";
    ctx.fillRect(0, 0, VIRTUAL_WIDTH, VIRTUAL_HEIGHT);

    const cx = VIRTUAL_WIDTH / 2;
    const cy = VIRTUAL_HEIGHT / 2;

    ctx.textAlign = "center";
    ctx.fillStyle = "#e2503a";
    ctx.font = "bold 32px system-ui, sans-serif";
    ctx.fillText("BANNED", cx, cy - 36);

    const name = this.ctxMgr.settings.playerName;
    if (name) {
      ctx.fillStyle = "#f5e9c8";
      ctx.font = "bold 15px system-ui, sans-serif";
      ctx.fillText(`"${name}"`, cx, cy - 6);
    }

    ctx.fillStyle = "rgba(245,233,200,0.85)";
    ctx.font = "13px system-ui, sans-serif";
    ctx.fillText("Your account has been banned.", cx, cy + 24);
    ctx.fillText("Contact an admin if you think", cx, cy + 44);
    ctx.fillText("this is a mistake.", cx, cy + 60);
  }
}
